module.exports = __webpack_public_path__ + "static/media/eyef.00b709fd.jpg";